module.exports = __webpack_public_path__ + "img/8.d323aa17.jpg";